// extracted by mini-css-extract-plugin
export var addressFields = "_no-0";
export var animationContainer = "_no-1";
export var footer = "_no-2";
export var lineItems = "_no-3";
export var modalContent = "_no-4";
export var orderName = "_no-5";
export var strong = "_no-6";
export var warning = "_no-7";